import { httpGet_New } from './api.service';
import { PaginatedResult } from '../types/PaginatedResult';
import { StockFilterGroup, StockFacilityResult } from '../types/Stock';

// Get Stock Filter Options (Carrier, ULD Type) for a station
const getStockFilters = async (stationId: string): Promise<StockFilterGroup[]> =>
  await httpGet_New<StockFilterGroup[]>('api/v2/stock/filters', { stationId });

// Get Stock By Facility — signature matches useNewTable's fetchAsync contract
const getStockByFacility = async (params: Record<string, any>): Promise<PaginatedResult<StockFacilityResult>> =>
  await httpGet_New<PaginatedResult<StockFacilityResult>>('api/v2/stock/facility', params);

export { getStockFilters, getStockByFacility };
